var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('v-chip',_vm._b({key:item.id,staticClass:"mx-2",on:{"click:close":function($event){return _vm.remove(item.id)}}},'v-chip',_vm.$attrs,false),[_vm._v(" "+_vm._s(item.attributes.description)+" - "+_vm._s(item.attributes.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }